import "./styles.module.css";
import GoogleIcon from "../../../../assets/icons/google-small-icon.webp";
import Cross from "../../../../assets/icons/Frame.png";
import { useState } from "react";
const CouponCard = ({ token }) => {
  const [showFullBanner, setShowFullBanner] = useState(true);
  const [email, setEmail] = useState("");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleUsingEmailLogin = (skinEmailCheck) => {
    if (!emailRegex.test(email) && !skinEmailCheck) {
      alert("Please enter a valid email address");
      return;
    }
    window.open(
      `/sign-in?redirect=/pricing/individual${
        email ? `&providerHint=tmc-passwordless&emailHint=${email}` : ""
      }`,
      "_self"
    );
  };

  const handleUsingGoogleLogin = () => {
    window.open(
      "/sign-in?redirect=/pricing/individual&providerHint=google",
      "_self"
    );
  };

  const handleCrossIcon = () => {
    setShowFullBanner(false);
  };
  const handleSubscribe = () => {
    window.open(
      "/pricing/individual",
      "_self"
    );
  };
  return (
    <>
      {showFullBanner ? (
        <div className="coupon-card-container">
          <div className="coupon-card-box">
            <img
              src={Cross}
              alt="cross"
              className="cross-icon"
              onClick={handleCrossIcon}
            />
            <div className="coupon-card-left">
              <p className="coupon-card-left-title">
                Save 50% and subscribe to The Morning Context
              </p>
              <p className="coupon-card-left-description">
                Read over 500 original, detailed stories every year on startups,
                corporates, stock markets and economic current affairs.
              </p>
              <p className="condition">*Applies to new user only</p>
            </div>
            <div className="coupon-card-right">
              {token ? (
                <Button handleSubscribe={handleSubscribe} />
              ) : (
                <>
                  <div className="button-container">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="email-field"
                      placeholder="Enter your email address"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleUsingEmailLogin(false);
                        }
                      }}
                    />
                    <button
                      className="button first"
                      onClick={() => handleUsingEmailLogin(true)}
                    >
                      Continue with Email
                    </button>
                    <button
                      className="button second"
                      onClick={handleUsingGoogleLogin}
                    >
                      <img
                        src={GoogleIcon}
                        alt="google-icon"
                        className="google-icon-img"
                      />
                      Continue with Google
                    </button>
                  </div>

                  <p className="sign-in">
                    Already a subscriber,{" "}
                    <span
                      className="sign-in-link"
                      onClick={handleUsingEmailLogin}
                    >
                      Sign in
                    </span>
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div>
            {/* <div className="coupon-card-container-fixed">
            <div className="coupon-card-container-fixed-inner">
              {" "}
              <div className="coupon-card-container-fixed-left">
                <p className="title">
                  In a world filled with noise and information, context is
                  everything.
                </p>
                <p className="heading">
                    Save 50% and join the independent publishing movement.
                </p>
              </div>
              <Button handleSubscribe={handleSubscribe} />
            </div>
          </div> */}
        </div>
      )}
    </>
  );
};

const Button = ({ handleSubscribe }) => {
  return (
    <div className="button-container-fixed">
      <button className="button-fixed" onClick={handleSubscribe}>
        SUBSCRIBE
      </button>
    </div>
  );
};

export default CouponCard;
